


















































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    componentDataType

} from "../types";

import {
    FETCH_PAGE_BY_ID
} from "../store/actions.names";
import {
    pageData
} from '../store/pageData';
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";
import {
    API_URL
} from "../global";
import axios from "axios";
import {
    globalToLocalURL
} from "../utils/common";

const DEFAULT_JOBAPP_FORM = {

    cv: null,
    type: null
};
@Component({
    name: "JobBtn",
    components: {
        ValidationObserver,
        ValidationProvider,
    }
})
export default class JobBtn extends Vue {
    @Prop() public compData!: string | null;
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;

    public jobappform: any = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;
    globalToLocalURL: any = globalToLocalURL;
    public data() {
        return {
            showModal: false
        }
    }
    get compURL() {
        return globalToLocalURL(this.pageData.meta.html_url + 'complete');
    }
    resetForm() {
        this.jobappform = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
    }
    public submitForm() {
        (this as any).$refs.observer.validate().then((valid: any) => {
            const data = JSON.parse(JSON.stringify(this.jobappform));
            data.job = (this as any).compData.id;
            //console.log(data);
            const formData = new FormData();
            // console.log(this.$refs.cv.files.length, this.$refs.image.files.length)
            if ((this as any).$refs.cv.files.length) {
                Object.keys(data).map((key: string) => {
                    if (["cv"].indexOf(key) == -1) {
                        // if (key == "date_of_birth"){
                        // formData.append(key, moment(data[key]).format('YYYY-MM-DD'));
                        // } else {
                        //     formData.append(key, data[key]);
                        // }
                        formData.append(key, data[key]);
                    }
                });
                formData.append("cv", (this.$refs.cv as any).files[0]);
                //  formData.append("image", (this.$refs.image as any).files[0]);
                axios
                    .post(`${API_URL}/cv/`, formData)
                    .then((resp: any) => {
                        this.submitted = true;
                        this.submitSuccess = true;
                        // this.$router.push({
                        //     to: this.submit.job_completion.url
                        // })
                    })
                    .catch((err: any) => {
                        this.submitted = true;
                    });

            }
        });
    }
    public created() {

        axios.get(`${API_URL}/others/settings/global-settings/`)
            .then(response => {
                (this as any).submit = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }
}
